/**
 * Helper to explicitly create a new config object from an API response body
 */
export default existingConfig => ({
  // TODO: Add some null check validations
  active: existingConfig.active,
  aircards: existingConfig.aircards,
  airlineCode: existingConfig.airlineCode,
  eventID: existingConfig.eventID,
  model: existingConfig.model,
  nai: existingConfig.nai,
  subnetGroup: existingConfig.subnetGroup,
  provision: existingConfig.provision,
});
